import { useContext, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Post from "../../api/Post";
import { SEND_SURVEY_EXTERNA } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import { isConsultorio } from "../../utils/isConsultorio";

function SendEncuetaConsultorio({t, cita, setShowSuccess, setShowModalServer, setErrorServer, noComienza}){
    const [sendingDoc, setSendingDoc] = useState(false)
    const {auth} = useContext(authContext)    
    
    const handleEnviarDocumentos = e =>{
        setSendingDoc(true)
        let dataAppointment = {
        }
        Post({url: `${SEND_SURVEY_EXTERNA}/${cita.id}`, data: dataAppointment, access_token: auth.data.access_token, header: true})
        .then(response=>{
            setSendingDoc(false)
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000);
        })
        .catch(error=>{
            //console.log("Error al acualizar el envío del historiál clínico", error)
            setSendingDoc(false)
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return (
        (!noComienza && isConsultorio(auth.data.role)) &&
        <Row className="mt-2">
            <Col>
                <label>
                    ¿Desea enviar la encuesta al paciente?
                </label>{' '}
                <Button type="button" 
                    size="sm" 
                    variant="outline-info"
                    onClick={handleEnviarDocumentos}
                >
                    {
                        sendingDoc ?
                        <div className="spinner-border spinner-border-sm text-info" role="status">
                            <span className="sr-only">Loading...</span>
                        </div> : 
                        `Sí, quiero enviarla`
                    }
                </Button>
            </Col>
        </Row>
    )
}

export default withTranslation()(SendEncuetaConsultorio)